<div class="block relative">

  <!-- Static label -->
  @if (hasLabel() && labelMode() === 'static') {
    <label
      [for]="inputId()"
      class="block mb-2 text-sm font-medium text-gray-700"
    >
      {{ label() }}
      @if (hasRequiredRule()) {
        <span class="ml-0.5 text-red-500">*</span>
      }
    </label>
  }

  <!-- Label switch -->
  @if (labelMode() === 'float' && hasLabel()) {
    <p-floatlabel [variant]="filled() ? 'in' : 'on'" class="block">
      <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
      <label [for]="inputId()">
        {{ label() }}
        @if (hasRequiredRule()) {
          <span class="ml-0.5 text-red-500">*</span>
        }
      </label>
    </p-floatlabel>
  } @else if (labelMode() === 'ifta' && hasLabel()) {
    <p-iftalabel class="block">
      <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
      <label [for]="inputId()">
        {{ label() }}
        @if (hasRequiredRule()) {
          <span class="ml-0.5 text-red-500">*</span>
        }
      </label>
    </p-iftalabel>
  } @else {
    <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
  }

  @if (helpText() && !isInvalid()) {
    <small class="block mt-1 text-xs text-gray-500">
      {{ helpText() }}
    </small>
  }

  @if (showErrors() && isInvalid() && errorMessage()) {
    <small class="block mt-1 text-xs text-red-500 animate-fade-in">
      <i class="pi pi-exclamation-circle mr-1"></i>
      {{ errorMessage() }}
    </small>
  }
</div>

<ng-template #inputTemplate>
  @if (hasIcon()) {
    <p-iconfield [class]="fluid() ? 'w-full block' : 'block'">
      @if (icon()?.position === 'left') {
        <p-inputicon
          [class]="icon()?.icon"
          [class.cursor-pointer]="icon()?.clickable"
          (click)="onIconClick()"
        />
      }

      <ng-container *ngTemplateOutlet="inputElement"></ng-container>

      @if (icon()?.position === 'right') {
        <p-inputicon
          [class]="icon()?.icon"
          [class.cursor-pointer]="icon()?.clickable"
          (click)="onIconClick()"
        />
      }
    </p-iconfield>
  } @else {
    <ng-container *ngTemplateOutlet="inputElement"></ng-container>
  }
</ng-template>

<ng-template #inputElement>
  <p-inputNumber
    [inputId]="inputId()"
    [min]="min()"
    [max]="max()"
    [step]="step()"
    [mode]="mode()"
    [prefix]="prefix()"
    [suffix]="suffix()"
    [minlength]="minLength()"
    [maxlength]="maxLength()"
    [pattern]="pattern()"
    [currency]="currency()"
    [currencyDisplay]="currencyDisplay()"
    [useGrouping]="useGrouping()"
    [disabled]="computedDisabled()"
    [readonly]="readonly()"
    [showButtons]="showButtons()"
    [showClear]="showClearButton()"
    [autofocus]="autoFocus()"
    [invalid]="isInvalid()"
    [class.w-full]="fluid()"
    [variant]="filled() ? 'filled' : 'outlined'"
    [name]="name() || undefined"
    [attr.aria-invalid]="isInvalid()"
    (onFocus)="onFocus($event)"
    (onBlur)="onBlur($event)"
    (onInput)="onInput($event)"
    [styleClass]="styleClass()"
  />
</ng-template>
